import { ERROR_BOUNDARY_STRATEGIES } from 'app/components/layouts/ErrorBoundary/ErrorBoundary';
import { ostroAdapter } from 'app/services/ostroAdapter';
import camelCase from 'lodash/camelCase';
import { useMemo } from 'react';

export enum UiRefreshNoResultsPageVersion {
  V1 = 'v1',
  V2 = 'v2',
}

export interface FeatureFlags {
  uiErrorBoundaryStrategy?: ERROR_BOUNDARY_STRATEGIES;
  uiRefreshDisableLogo: boolean;
  uiRefreshDisableRotatingMessages: boolean;
  uiRefreshFixVAAlignment: boolean;
  uiRefreshFontSizeIncrease: string;
  uiRefreshIsiOnArticlePages: boolean;
  uiRefreshMainColorAsIs: string;
  uiRefreshNextBestResourceCta: boolean;
  uiRefreshNoResultsPageVersion: UiRefreshNoResultsPageVersion;
  uiRefreshPreLaunchUiUpdates: boolean;
  uiRefreshReduceInputFontSize: boolean;
  uiRefreshReduceWhitespaceBetweenCategories: boolean;
  uiRefreshSuggestedArticlesHeading: string;
  uiRefreshUpdatedResourceIcons: boolean;
  uiShowFooterLinksInLiveChat: boolean;
  uiShowSuggestedArticle: boolean;
  uiEngagementHubConversationalAi: boolean;
  webSearchInTailor: boolean;
}

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export function camelcaseKeys(obj: any): any {
  if (typeof obj !== 'object' || obj === null) {
    return obj;
  }

  if (Array.isArray(obj)) {
    return obj.map(camelcaseKeys);
  }

  return Object.keys(obj).reduce((acc, key) => {
    const camelKey = camelCase(key);
    acc[camelKey] = camelcaseKeys(obj[key]);
    return acc;
  }, {} as any); // eslint-disable-line @typescript-eslint/no-explicit-any
}

export default function useFeatureFlags(): FeatureFlags {
  const featureFlags = ostroAdapter.getFeatureFlags();

  return useMemo(() => camelcaseKeys(featureFlags), [featureFlags]);
}
